<template>
    <div>
        <div v-if="loading">Loading...</div>

        <div
            v-else-if="!paginatedGarnitures.length"
            class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
        >
            <img
                v-if="searchText.length === 0"
                src="/img/icons/empty-goods.svg"
                class="dashboard-empty__img ofi"
            />
            <img
                v-else
                src="/img/icons/empty-search.svg"
                class="dashboard-empty__img dashboard-empty__img--search ofi"
            />
            <div class="dashboard-empty__title pt-5">
                По вашему запросу ничего не найдено.
            </div>
        </div>

        <div v-show="!loading && paginatedGarnitures.length">
            <section class="cabinet-table-options-wrap mb-0">
                <div
                    class="cabinet-table-options flex flex-align-center pt-0 pb-0"
                >
                    <div class="d-none d-md-block">
                        {{
                            Math.min(
                                pagination.page * pagination.pageSize,
                                pagination.totalProducts
                            )
                        }}

                        из {{ pagination.totalProducts }}
                    </div>

                    <div
                        class="cabinet-table-options__sort flex flex-align-center ml-md-auto"
                    >
                        <div
                            class="dropdown bootstrap-select select select--small cabinet__catalog-select mr-2"
                        >
                            <select-picker
                                :current-value="sort"
                                :options="sortVariations"
                                key-value="value"
                                key-title="title"
                                select-width="176"
                                :classes="['select']"
                                @onChange="onSortChange($event)"
                            />
                        </div>

                        <button
                            type="button"
                            class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--view  ml-auto"
                            @click="toggleCatalogModeAndListView('grid')"
                        ></button>
                        <button
                            type="button"
                            class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn--view-list d-none d-lg-block"
                            @click="toggleCatalogModeAndListView('list')"
                        ></button>
                        <button
                            type="button"
                            class="cabinet-btn-icon cabinet-btn-icon--transparent cabinet-btn-icon--small cabinet-btn-icon--garniture active"
                        ></button>
                    </div>
                </div>

                <section
                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-flex pt-md-0"
                >
                    <!-- <div class="d-none d-md-block">
                        <select-picker
                            :current-value="pagination.pageSize"
                            :options="pageSizesObj"
                            key-value="id"
                            key-title="title"
                            select-width="80"
                            :classes="['select', 'select--small']"
                            @onChange="onPageSizeChange($event)"
                        />
                    </div> -->
                    <div class="d-md-none">
                        {{
                            Math.min(
                                pagination.page * pagination.pageSize,
                                pagination.totalProducts
                            )
                        }}

                        из {{ pagination.totalProducts }}
                    </div>

                    <!-- <table-pagination
                        :current-page="pagination.page"
                        :total-pages="pagination.totalPages"
                        :total-products="pagination.totalProducts"
                        :disable-scroll-top="isMobile"
                        @setPage="onSetPage($event)"
                    /> -->
                </section>
            </section>

            <div class="pb-5">
                <catalog-garnitures-item
                    v-for="garniture in paginatedGarnitures"
                    :key="garniture.set_id"
                    :garniture="garniture"
                />
            </div>

            <!-- <section
                class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-md-flex"
            >
                <select-picker
                    :current-value="pagination.pageSize"
                    :options="pageSizesObj"
                    key-value="id"
                    key-title="title"
                    select-width="80"
                    :classes="['select', 'select--small']"
                    @onChange="onPageSizeChange($event)"
                />

                <table-pagination
                    :current-page="pagination.page"
                    :total-pages="pagination.totalPages"
                    :total-products="pagination.totalProducts"
                    :disable-scroll-top="isMobile"
                    @setPage="onSetPage($event)"
                />
            </section> -->

            <section
                v-if="pagination.page < pagination.totalPages"
                class="flex flex-column flex-align-center pb-4"
            >
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default"
                    :disabled="pagination.page >= pagination.totalPages"
                    @click="updateGarnituresList(pagination.page + 1, true)"
                >
                    Загрузить еще
                </button>
            </section>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import getNameById from '@/mixins/getNameById'
import onResize from '@/mixins/on-resize'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import CatalogGarnituresItem from '@/components/Cabinet/Retailer/Catalog/GarnituresItem'

export default {
    name: 'RetailerCatalogGarnituresList',
    components: {
        SelectPicker,
        // TablePagination,
        CatalogGarnituresItem
    },
    mixins: [getNameById, onResize],
    props: {
        filter: {
            type: Object,
            required: true
        },
        searchText: {
            type: String,
            required: true
        },
        pageSizes: {
            type: Array,
            default: () => [10, 20, 50, 100]
        },
        filterTimeStamp: {
            type: String,
            required: true
        },
        brandCatalogBrandId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            loading: true,
            sort: 'set_article:asc',
            sortVariations: [
                {
                    value: 'set_article:desc',
                    title: 'По артикулу ↑'
                },
                {
                    value: 'set_article:asc',
                    title: 'По артикулу ↓'
                }
            ]
        }
    },
    computed: {
        ...mapState('retailerSets', [
            'garnitures',
            'mobileGarnitures',
            'pagination',
            'errors'
        ]),
        ...mapGetters('finenesses', {
            getFinenessesNamesArr: 'getSupplierFinenessesNamesArr'
        }),
        finenessesNamesArr() {
            return this.getFinenessesNamesArr(this.filter.finenesses.value)
        },
        pageSizesObj() {
            return this.pageSizes.map(item => ({
                id: item,
                title: item
            }))
        },
        isBrandCatalog() {
            return !!this.brandCatalogBrandId
        },
        paginatedGarnitures() {
            // if (document.documentElement.clientWidth > 767) {
            //     return this.garnitures
            // }
            return this.mobileGarnitures
        }
    },
    watch: {
        filterTimeStamp: function(val) {
            this.updateGarnituresList(1)
        }
    },
    async mounted() {
        await this.updateGarnituresList(this.pagination.page)
    },
    async destroyed() {
        this.clearGarnitures()
    },
    methods: {
        ...mapMutations('retailerSets', ['SET_PAGINATION']),
        ...mapActions('retailerSets', [
            'getGarnitures',
            'setPagination',
            'clearGarnitures'
        ]),

        updateGarnituresList: _.debounce(function(
            page = 1,
            isMobilePagination = false
        ) {
            this.$Progress.start()

            const data = {
                page,
                isMobilePagination,
                sort_by: this.sort.split(':')[0],
                sort_type: this.sort.split(':')[1]
            }

            Object.keys(this.filter).forEach(item => {
                if (!this.filter[item].isDefault) {
                    let valuesArr = [...this.filter[item].value]

                    if (item === 'finenesses') {
                        valuesArr = [...this.finenessesNamesArr]
                    }

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.isBrandCatalog) {
                data['brands'] = [this.brandCatalogBrandId]
            }

            if (this.searchText) {
                data.search = this.searchText
            }

            this.getGarnitures(data).then(() => {
                this.loading = false
            })
        },
        800),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateGarnituresList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateGarnituresList(1)
        },
        toggleCatalogModeAndListView(type) {
            this.$emit('toggleCatalogMode', 'products')
            this.$emit('changeListView', type)
        },
        onSortChange(value) {
            this.sort = value
            this.updateGarnituresList()
        }
    }
}
</script>
